import { useMemo } from 'react';

import { useTypeWriter } from '../../../hooks/useTypeWriter';

export const ScriptTab = props => {
  const content = useMemo(
    () => `
        <span class="whitespace-preline">
            ${props.words}
        </span>
    `,
    [props.words],
  );

  const { displayResponse } = useTypeWriter(content, true);

  return (
    <p
      id="typed"
      className="text-base font-medium lg:text-lg"
      dangerouslySetInnerHTML={{ __html: displayResponse }}
    ></p>
  );
};
